/**
 * Clickable <th> for column-header sorting. Click cycles asc -> desc -> asc
 * (no third "unsorted" state — keeps the interaction simple).
 */

import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';
import { clsx } from 'clsx';
import type { SortDirection } from '../../utils/sort';

interface SortableHeaderProps {
  label: React.ReactNode;
  field: string;
  activeField: string | null;
  activeDirection: SortDirection;
  onSort: (field: string) => void;
  align?: 'left' | 'right';
}

export function SortableHeader({
  label,
  field,
  activeField,
  activeDirection,
  onSort,
  align = 'left',
}: SortableHeaderProps) {
  const isActive = activeField === field;

  return (
    <th
      className={clsx(
        'px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer select-none hover:text-gray-700',
        align === 'right' ? 'text-right' : 'text-left'
      )}
      onClick={() => onSort(field)}
    >
      <span className={clsx('flex items-center gap-1', align === 'right' && 'justify-end')}>
        {label}
        {isActive ? (
          activeDirection === 'asc' ? (
            <ArrowUp className="w-3 h-3" />
          ) : (
            <ArrowDown className="w-3 h-3" />
          )
        ) : (
          <ChevronsUpDown className="w-3 h-3 text-gray-300" />
        )}
      </span>
    </th>
  );
}
